<template>
  <a-modal centered
           :visible="visible"
           title="商标询价"
           @ok="on_submit"
           @cancel="cancel"
           :confirmLoading="submitting"
           :width="420">
    <a-form-model :model="form" ref="enquiry_create" :rules="rules" layout="vertical">

      <a-form-model-item label="客户ID" prop="member_id">
        <a-select
            class="spotlight"
            show-search
            :show-arrow="false"
            :dropdownMatchSelectWidth="false"
            placeholder="快速搜索姓名、手机号码..."
            :filter-option="false"
            @search="on_membersearch"
            style="transition:0.2s width"
            option-label-prop="value"
            v-model="form.member_id"
        >
          <a-spin v-if="loading_member" slot="notFoundContent" size="small" />

          <a-select-opt-group v-for="d in data_member" :key="d.id">
            <a-select-option :value="d.id" :key="d.id" :name="d.name" :item="d">
              <div>
                客户姓名：{{ d.name }}，类型：{{d.taxonomy_text}}，公司名称：{{ d.com_name }}
              </div>
            </a-select-option>

          </a-select-opt-group>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="报价" prop="sell_price">
        <a-input v-model="form.sell_price" allowClear />
      </a-form-model-item>

      <a-form-model-item label="选择商标询价等级">
        <a-radio-group v-model="form.level" button-style="solid">
          <a-radio-button
              :value="item.value"
              v-for="item in enquiry_array"
              :key="item.value"
          >
            <a-tooltip>
              <template slot="title">
                {{ item.name }}
              </template>
              {{ item.value }}
            </a-tooltip>
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

<!--      <a-form-model-item label="类型" prop="taxonomy">
        <a-select v-model="form.taxonomy" v-decorator="['select',{ rules: [{ required: true, message: '请选择类型' }] },]" placeholder="">
          <a-select-option value="2">渠道</a-select-option>
          <a-select-option value="1">直客</a-select-option>
          <a-select-option value="3">代理商</a-select-option>
        </a-select>
      </a-form-model-item>-->

      <a-form-model-item label="备注">
        <a-textarea v-model="form.remarks" allowClear />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
let init_form = {
  member_id: null,
  sell_price: null,
  taxonomy: "1",
  remarks: null,
};
export default {
  props: {
    visible: {
      default: false
    },
    record: null,
    callback: null
  },
  data() {
    return {
      submitting: false,
      loading_member: false,
      data_member: [],
      form: {},
      rules: {
        member_id: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "用户id必填"
          }
        ],
        sell_price: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "价格必填"
          }
        ],
        taxonomy: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "类型必填"
          }
        ],
        remarks: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "备注必填"
          }
        ],
      }
    };
  },
  created() {
    this.form = JSON.parse(JSON.stringify(init_form));
  },
  watch: {
    visible(v) {
      if (v && this.record) {
        Object.keys(this.form).map((v) => {
          if (Object.prototype.hasOwnProperty.call(this.record, v)) {
            switch (v) {
              case "is_include_invoice":
              case "is_include_transfer":
              case "is_include_notary":
                this.form[v] = !!this.record[v];
                break;
              default:
                this.form[v] = this.record[v];
            }
          }
        });
      }
    }
  },
  methods: {
    cancel() {
      this.form = JSON.parse(JSON.stringify(init_form));

      this.$emit("close");

    },
    on_submit() {
      this.$refs["enquiry_create"].validate((valid) => {
        if (valid) {
          this.submitting = true;
          this.$http
            .post("/trademark/enquiry/" + this.record.applyNo, this.form)
            .then((res) => {
              if (res.success) {
                this.$message.success(res.message);
                this.load();
                this.cancel();
                if (this.callback) {
                  this.callback(JSON.parse(JSON.stringify(this.form)));
                }
                this.visible = false;

                this.form = JSON.parse(JSON.stringify(init_form));

              } else {
                this.$error({ title: "失败", centered: true, content: res.message });
              }
            })
            .catch(() => {
            })
            .then(() => {
              this.submitting = false;
            });

          this.$emit("close");

        } else {
          this.$message.error("请检查并填写完需要录入的内容");
          return false;
        }
      });
    },

    on_membersearch(v) {
      this.loading_member = true;
      this.$http
          .get(`/member/accessible?type=plain&wd=${v}`)
          .then((response) => {
            if (response.success) {
              this.data_member = response.data;
            }
          })
          .catch(() => {})
          .then(() => {
            this.loading_member = false;
          });
    },

    after_close() {
      this.$refs["enquiry_create"].resetFields();

      this.form = JSON.parse(JSON.stringify(init_form));
    }
  }
};
</script>
